import { clsx, type ClassValue } from 'clsx'
import { extendTailwindMerge } from 'tailwind-merge'

/**
 * tailwind-merge only knows the stock font-size scale. `text-13` (the sidebar and
 * breadcrumb size added in globals.css) would otherwise be classified as a text
 * colour and dropped whenever it meets `text-muted-foreground` in the same call.
 * `text-2xs` already matches the t-shirt pattern; it is listed for clarity.
 */
const twMerge = extendTailwindMerge({
    extend: {
        theme: {
            text: ['13', '2xs']
        }
    }
})

export function cn(...inputs: ClassValue[]) {
    return twMerge(clsx(inputs))
}
